import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';

@Component({
  selector: 'app-deduction-rules',
  templateUrl: './deduction-rules.component.html',
  styleUrls: ['./deduction-rules.component.scss']
})
export class DeductionRulesComponent implements OnInit {
  // variables
    LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
    currentLang:any;
    tabs:any=[];
    activetab:number=0;
    customDataSourceDelayRule:any;
    customDataSourcAbsenceRule:any;
    lastItem:string;
    activetabs:any=[]
    selectedIndex:number;
    constructor(public gt:genericCustomStoreService,public router:Router) {
        this.currentLang = localStorage.getItem(this.LOCALIZATION_LOCAL_STORAGE_KEY);
        this.gt.sessiondata.subscribe(data=>this.tabs=data)
        this.lastItem = this.router.url.substring(this.router.url.lastIndexOf('/') + 1)
       //get tab data
       this.tabs.forEach((tab:[])=>{
       tab.filter((ele:{externalUrl:string})=>{      
       ele.externalUrl.includes(this.lastItem) ? this.activetabs= tab :  ''
        })           
       })   
       this.changekey()
      }
      ngOnInit(): void {
      //activttab
      let activetab= this.activetabs.filter((tab:any)=>{      
        return tab.externalUrl.includes(this.lastItem) ? tab : ''
      })     
      let index = this.activetabs.indexOf(activetab[0])
      this.selectedIndex=index
 }

  selectTab(e:any){  
    this.router.navigate([e.itemData.externalUrl])
    this.changekey()

 }
 changekey(){
  //change key because dx-tabs use text key to read datascource
  for (var i = 0; i <this.activetabs.length; i++) {
    var o = this.activetabs[i];    
    o.text = this.currentLang=='ar'? o.nameAr : o.nameEn
  }    
  }
}
